module.exports = __webpack_public_path__ + "img/ring_g_c_0_0@3x.a9f76ab1.png";